<div class="container-fluid px-0" style="height:100%">
    <mat-toolbar style="height: 10%;">
        <div class="row">
            <div class="col-sm-12 text-center webkitScrollDisable">
                <img src="./../../assets/svg/Proteen-Logo.svg" href="#" alt="proteen-logo" class="logo cursor-pointer border-none" (click)="navigateToHome()">
            </div>
        </div>
    </mat-toolbar>
    <div class="login-container signin-container" style="height: 90%;">
        <div class="row">
            <div class="col-md-7 vertical pr-0 m-hide">
                <owl-carousel-o [options]="customOptions">
                    <!-- <ng-template carouselSlide><img src="./assets/images/other/singup/Banner 2.png"></ng-template>
                    <ng-template carouselSlide><img src="./assets/images/other/singup/Banner 3.png"></ng-template>
                    <ng-template carouselSlide><img src="./assets/images/other/singup/Break_Free.png"></ng-template> -->

                    <!-- added new banner on 11042023 -->
                    <ng-template carouselSlide><img src="./assets/images/other/singup/New_Banner_1.png"></ng-template>
                    <ng-template carouselSlide><img src="./assets/images/other/singup/New_Banner_2.png"></ng-template>
                    <ng-template carouselSlide><img src="./assets/images/other/singup/New_Banner_3.png"></ng-template>
                </owl-carousel-o>
    
            </div>
            <div class="col-md-5 sign-in-box">
                <div class="ScollBar">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>
